import { useNavigate } from "@/lib/router-compat";
import { Wallet } from "lucide-react";
import { useCashCredits } from "@/hooks/useCashCredits";

/**
 * Cash credits chip — redeemable wallet balance.
 * Hidden when balance is $0.
 */
const CashCreditsChip = () => {
  const navigate = useNavigate();
  const { balanceCredits, dollarBalance, loading } = useCashCredits();

  if (loading || balanceCredits === 0) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/rewards")}
      className="hidden sm:flex items-center gap-1.5 text-sm cursor-pointer hover:opacity-80 transition-opacity"
      aria-label={`Cash credits: ${dollarBalance}`}
    >
      <Wallet size={16} className="text-[hsl(var(--brand))]" />
      <span className="font-semibold text-foreground">{dollarBalance}</span>
      <span className="text-xs text-muted-foreground">cash</span>
    </button>
  );
};

export default CashCreditsChip;